export class DisconnectModalController {
    static $inject = ['close', 'onDeleteForm', 'model', '$timeout'];
    constructor(close, onDeleteForm, model, $timeout) {
        'ngInject';
        this.close = close;
        this.onDeleteForm = onDeleteForm;
        this.model = model;
        this.$timeout = $timeout;
        this.onInputChange = async (event) => {
            this.model.text = event.detail.value;
            this.setDisconnectButtonDisabledStatus();
        };
        this.onCheckboxChange = async (event) => {
            this.model.agree = event.detail.checked;
            this.setDisconnectButtonDisabledStatus();
        };
        this.setDisconnectButtonDisabledStatus = () => {
            this.$timeout(() => {
                this.disconnectButtonDisabled = !this.model.agree || !this.model.text;
            });
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.close();
            }
        };
        this.disconnectButtonDisabled = false;
    }
    $onInit() {
        document
            .getElementById('agree')
            .addEventListener('bdsChange', this.onCheckboxChange);
        document
            .getElementById('reason')
            .addEventListener('bdsChange', this.onInputChange);
        document
            .getElementById('wa-modal-disconnect')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
    async continue() {
        try {
            if (this.model.text && this.model.agree) {
                await this.onDeleteForm(this.model);
                this.close();
            }
        }
        catch (err) {
            console.error(err);
        }
    }
}
DisconnectModalController.$inject = ['close', 'onDeleteForm', 'model', '$timeout'];
